import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { authSelector } from "../../redux/modules/auth/userSelector";
import { verifyMfa } from "../../redux/modules/auth/actions";
import { resetMfa } from "../../redux/modules/auth/slice";

export default function AdminOtp() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const { status, tempToken, user, message } = useSelector(authSelector);

  const handleVerifyOtp = () => {
    if (!code) {
      setError("Please enter the verification code");
      return;
    }
    if (!tempToken) {
      setError("Session expired. Please login again.");
      navigate("/login");
      return;
    }
    dispatch(verifyMfa({ tempToken, code }))
      .unwrap()
      .catch((err: any) => {
        console.log("Verify MFA Error:", err);
      
        const msg =
          err?.error?.message ||
          err?.message ||
          "Invalid verification code";
      
        setError(msg);
      });
      
      
  };

  useEffect(() => {
    // Only navigate if we have a verified admin user
    if (user?.role === "admin") {
      dispatch(resetMfa());
      navigate("/home");
    }
  }, [user, navigate, dispatch]);

  // Clear error when user types
  useEffect(() => {
    setError("");
  }, [code]);
  

  // Handle Enter key press
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleVerifyOtp();
    }
  };

  return (
    <>
      {status === "loading" && <Spinner />}

      <div className="sign-up-wrap">
        <h1 className="logo">
          Wendwise
          <sup className="tm">TM</sup>
        </h1>

        <div className="form-container-wrap">
          <form
            className="form-container1"
            onSubmit={(e) => e.preventDefault()}
          >
            <h2>Verify Your Identity</h2>
            <p className="text-muted mb-4">
              Enter the verification code sent to your email
            </p>

            <div className="form-group">
              {error && <p className="text-danger font-weight-bold">{error}</p>}
              {status === "failed" && message && !error && (
                <p className="text-danger font-weight-bold">{message}</p>
              )}

              <label htmlFor="verification-code">Verification Code</label>
              <input
                type="text"
                className="form-control"
                id="verification-code"
                placeholder="Enter 6-digit code"
                required
                value={code}
                onChange={(e) => setCode(e.target.value)}
                onKeyPress={handleKeyPress}
                maxLength={6}
                autoComplete="off"
              />
            </div>

            <button
              type="submit"
              className="btn mt-5 btn-block"
              id="btn-submit"
              onClick={handleVerifyOtp}
            >
              Verify Code
            </button>

            <div className="text-center mt-3">
            <button
  type="button"
  className="btn btn-link"
  onClick={() => {
    dispatch(resetMfa());
    navigate("/login");
  }}
>
  Back to Login
</button>

            </div>
          </form>
        </div>
      </div>
    </>
  );
}